var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7903 17.199V14.2916C38.7903 6.39861 32.3918 0 24.4987 0C16.6056 0 10.207 6.39861 10.207 14.2916V17.199C6.49126 18.8207 4.08739 22.4875 4.08203 26.5416V38.7916C4.08873 44.4267 8.6552 48.9933 14.2903 49H34.7069C40.342 48.9933 44.9085 44.4267 44.9153 38.7916V26.5416C44.91 22.4875 42.5061 18.8207 38.7903 17.199ZM26.5403 34.7084C26.5403 35.8359 25.6262 36.75 24.4987 36.75C23.3711 36.75 22.457 35.8359 22.457 34.7084V30.625C22.457 29.4974 23.3711 28.5834 24.4987 28.5834C25.6262 28.5834 26.5403 29.4974 26.5403 30.625V34.7084ZM34.707 16.3334H14.2903V14.2917C14.2903 8.65386 18.8607 4.08337 24.4987 4.08337C30.1366 4.08337 34.707 8.65376 34.707 14.2917V16.3334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockUnlock);
export default __webpack_public_path__ + "static/media/lock-unlock.fe856df94bcccbad03d74711dbde7b8c.svg";
export { ForwardRef as ReactComponent };